import React, { useState } from 'react';
import { Navbar, Footer, PrivacyPolicyModal, TermsModal } from './components';
import { Home } from './pages';

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleFooterClick = (modalType) => {
    if (modalType === 'privacy') {
      setShowPrivacyPolicy(true);
    } else if (modalType === 'terms') {
      setShowTerms(true);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Home />
      </main>
      <Footer onFooterClick={handleFooterClick} />

      {/* Modals */}
      <PrivacyPolicyModal
        isOpen={showPrivacyPolicy}
        onClose={() => setShowPrivacyPolicy(false)}
      />
      <TermsModal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
      />
    </div>
  );
}

export default App;
